// extracted by mini-css-extract-plugin
export var editButton = "_on-0";